/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GcpEncryptionKey {
  /**
  * The name of the encryption key
  */
  'name': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpEncryptionKey.attributeTypeMap;
  }

  public constructor() {
  }
}

